<div class="app-modal-dialog" *ngIf="_show">
    <div class="overlay">
    </div>
    <div class="window shadow-lg" [ngClass]="windowClass">
        <div class="app-modal-header">
            <span>{{ title }}</span>
            <a href="javascript:;" (click)="show = false" class="app-modal-close"><i class="fa fa-times"></i></a>
        </div>
        <ng-content></ng-content>
    </div>
</div>